import TopLayout from './components/top-layout'
import theme from './theme'

export default function wrapWithProvider({ element }: { element: React.ReactNode }) {
  return <TopLayout theme={theme}>{element}</TopLayout>
}
